import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeExpenseGroupList from './HomeExpenseGroupList';
import { ExpenseType } from '../../types/homeExpenses';

const HomeExpenseGroupsPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isPersonal = location.pathname.includes('personal');
  const expenseType = isPersonal ? ExpenseType.Personal : ExpenseType.Home;

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link 
          color="inherit" 
          href="/expenses" 
          onClick={(e) => {
            e.preventDefault();
            navigate('/expenses');
          }}
          underline="hover"
          sx={{ cursor: 'pointer' }}
        >
          Despesas
        </Link>
        <Typography color="text.primary">Grupos de despesas {isPersonal ? 'pessoais' : 'da casa'}</Typography>
      </Breadcrumbs>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Gira os seus grupos de despesas e receitas {isPersonal ? 'pessoais' : 'da casa'}. Os grupos ajudam a organizar os dados financeiros e permitem melhores relatórios e análises.
      </Typography>

      <HomeExpenseGroupList expenseType={expenseType} />
    </Box>
  );
};

export default HomeExpenseGroupsPage;
